import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { AgentMailboxAdminService } from "@/services/admin/AgentMailboxAdminService";
import type { AgentMailboxUpdateInput } from "@/types/agent-mailboxes";

const PAGE_SIZE = 50;
const QUERY_KEY = ["admin-agent-mailboxes"];

export const useAgentMailboxes = (page: number = 1) =>
  useQuery({
    queryKey: [...QUERY_KEY, page],
    queryFn: () => AgentMailboxAdminService.list(PAGE_SIZE, (page - 1) * PAGE_SIZE),
    staleTime: 30 * 1000,
  });

export const useUpdateAgentMailbox = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: AgentMailboxUpdateInput }) =>
      AgentMailboxAdminService.update(id, input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QUERY_KEY }),
  });
};

export const useDeprovisionAgentMailbox = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => AgentMailboxAdminService.deprovision(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QUERY_KEY }),
  });
};
